<template>
  <div class="config_layout">
    <div
      v-show="ishowEntry(v.keywords, v.pcUrl)"
      v-for="(v, i) in configList"
      :key="i"
    >
      <a :href="v.pcUrl" target="_blank">
        <img :src="v.pcPhoto || v.photo" width="620" :alt="v.title" />
      </a>
      <div class="adbox" v-if="v.type == 'ad'"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "searchConfig",
  props: {
    keyword: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      configList: [], // 配置列表
      keywords: this.keyword,
    };
  },
  watch: {
    keyword: {
      // 监听的选项
      handler(newValue) {
        // 处理函数
        if (newValue && newValue.length > 0) {
          this.keywords = newValue;
          this.getConfig(this.keywords);
        }
      },
      // 是否深度监听
      deep: false,
      // 是否立即调用处理函数
      immediate: false,
    },
  },
  methods: {
    //获取本地分期价格
    async getConfig(keyword) {
      try {
        if (keyword.length == 0) return;
        const res = await this.getSearchConfig({});
        if (res.code === 200 && res.top) {
          this.configList = res.top; 
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 是否展示阅见入口
    ishowEntry(keywordList, pcUrl) {
      if (!pcUrl) {
        return false;
      }
      return keywordList.some((v) => {
        return v === this.keyword.replace(' ','');
      });
    },
  },
  mounted() {
    this.keywords = this.keyword.replace(' ','');
    this.getConfig(this.keywords);
  },
};
</script>

<style lang="scss" scoped>
.config_layout {
  width: 620px;
  padding-bottom: 12px;
  position: relative;
  a {
    display: block;
  }
  .adbox {
    position: absolute;
    bottom: 12px;
    right: 0;
    width: 19px;
    height: 11.09px;
    background: url(https://www1.pconline.com.cn/zt/20160901/ad1p.png) center
      no-repeat;
    background-size: 100%;
  }
}
</style>